export interface ProcessInspectionRequest {
  inspectionId: string
  collectionId: string
  collectionNo: string
}

export function ProcessInspectionRequestToJSON(
  value: ProcessInspectionRequest
): any {
  return {
    inspection_id: value.inspectionId !== '' ? value.inspectionId : undefined,
    collection_id: value.collectionId !== '' ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
